// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.part-machine-assign .assign-page-body {
  height: auto !important;
}
.part-machine-assign .assign-wizard-card {
  padding: 1.25rem 1.5rem 1.5rem;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border-card-file, #e2e8f0);
  border-radius: var(--m-border-radius-md, 8px);
  box-shadow: var(--m-box-shadow-car, 0 1px 3px rgba(0, 0, 0, 0.08));
}
.part-machine-assign .assign-wizard-card .assign-footer {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
}
.part-machine-assign .assign-stepper {
  display: flex;
  align-items: flex-start;
  gap: 0;
  margin-bottom: 8px;
  padding: 0;
  list-style: none;
  overflow-x: auto;
}
.part-machine-assign .assign-stepper__item {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}
.part-machine-assign .assign-stepper__item:last-child .assign-stepper__connector {
  display: none;
}
.part-machine-assign .assign-stepper__btn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  min-width: 0;
}
.part-machine-assign .assign-stepper__btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.part-machine-assign .assign-stepper__btn:not(:disabled):hover .assign-stepper__label {
  color: var(--m-primary, #2563eb);
}
.part-machine-assign .assign-stepper__top {
  display: flex;
  align-items: center;
  gap: 8px;
}
.part-machine-assign .assign-stepper__num {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  border: 2px solid #cbd5e1;
  color: #64748b;
  background: #fff;
}
.part-machine-assign .assign-stepper__label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}
.part-machine-assign .assign-stepper__connector {
  flex: 1 1;
  height: 2px;
  min-width: 16px;
  margin: 0 12px;
  margin-top: 14px;
  background: #e2e8f0;
}
.part-machine-assign .assign-stepper__item--active .assign-stepper__num {
  border-color: var(--m-primary, #2563eb);
  background: var(--m-primary, #2563eb);
  color: #fff;
}
.part-machine-assign .assign-stepper__item--active .assign-stepper__label {
  color: var(--m-primary, #2563eb);
}
.part-machine-assign .assign-stepper__item--done .assign-stepper__num {
  border-color: #16a34a;
  background: #16a34a;
  color: #fff;
}
.part-machine-assign .assign-stepper__item--done .assign-stepper__label {
  color: #15803d;
}
.part-machine-assign .assign-stepper__item--done .assign-stepper__connector {
  background: #86efac;
}
.part-machine-assign .assign-step-hint {
  font-size: 0.8125rem;
  color: #64748b;
  margin-bottom: 20px;
  padding: 10px 14px;
  background: #f8fafc;
  border-radius: 6px;
  border-left: 3px solid var(--m-primary, #2563eb);
}
.part-machine-assign .assign-section {
  padding: 0;
}
.part-machine-assign .assign-section__title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}
.part-machine-assign .assign-section__desc {
  font-size: 0.8125rem;
  color: #64748b;
  margin-bottom: 16px;
}
.part-machine-assign .entry-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.part-machine-assign .entry-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid var(--m-border-color, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.part-machine-assign .entry-card:hover {
  border-color: #94a3b8;
}
.part-machine-assign .entry-card--active {
  border-color: var(--m-primary, #2563eb);
  box-shadow: 0 0 0 1px var(--m-primary, #2563eb);
  background: #f8fafc;
}
.part-machine-assign .entry-card__main {
  flex: 1 1;
  min-width: 0;
}
.part-machine-assign .entry-card__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 4px;
}
.part-machine-assign .entry-card__meta {
  font-size: 0.75rem;
  color: #64748b;
}
.part-machine-assign .entry-card__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}
.part-machine-assign .entry-card__form {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}
.part-machine-assign .entry-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--m-border-color, #e2e8f0);
}
.part-machine-assign .entry-tab {
  padding: 6px 12px;
  font-size: 0.8125rem;
  font-weight: 500;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
}
.part-machine-assign .entry-tab--active {
  border-color: var(--m-primary, #2563eb);
  background: #eff6ff;
  color: var(--m-primary, #2563eb);
}
.part-machine-assign .assign-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--m-border-color, #e2e8f0);
}
.part-machine-assign .variant-panel {
  border: 1px solid var(--m-border-color, #e2e8f0);
  border-radius: 8px;
  padding: 14px 16px;
  background: #fafbfc;
}
.part-machine-assign .variant-panel__toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #e2e8f0;
}
.part-machine-assign .variant-settings-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.part-machine-assign .variant-settings-card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.part-machine-assign .variant-settings-card--open {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}
.part-machine-assign .variant-settings-card--done {
  border-color: #86efac;
  background: #f0fdf4;
}
.part-machine-assign .variant-settings-card__header {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
}
.part-machine-assign .variant-settings-card__header:hover {
  background: rgba(241, 245, 249, 0.6);
}
.part-machine-assign .variant-settings-card--done .part-machine-assign .variant-settings-card__header:hover {
  background: rgba(220, 252, 231, 0.5);
}
.part-machine-assign .variant-settings-card__status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 600;
  flex-shrink: 0;
}
.part-machine-assign .variant-settings-card__status--done {
  background: #22c55e;
  color: #fff;
}
.part-machine-assign .variant-settings-card__title {
  flex: 1 1;
  min-width: 0;
}
.part-machine-assign .variant-settings-card__label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
}
.part-machine-assign .variant-settings-card__meta {
  display: block;
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 2px;
}
.part-machine-assign .variant-settings-card__chevron {
  color: #94a3b8;
  display: flex;
  align-items: center;
}
.part-machine-assign .variant-settings-card__badge {
  font-size: 0.6875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 4px 10px;
  border-radius: 999px;
  background: #fef3c7;
  color: #b45309;
  flex-shrink: 0;
}
.part-machine-assign .variant-settings-card__badge--done {
  background: #dcfce7;
  color: #15803d;
}
.part-machine-assign .variant-settings-card__body {
  padding: 0 14px 14px 62px;
  border-top: 1px solid #f1f5f9;
  animation: assign-card-open 0.2s ease;
}
.part-machine-assign .variant-settings-card__fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding-top: 14px;
}
@media (max-width: 576px) {
  .part-machine-assign .variant-settings-card__fields {
    grid-template-columns: 1fr;
  }
}
.part-machine-assign .variant-settings-card__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.part-machine-assign .variant-settings-card__section-title {
  margin: 16px 0 4px;
  padding-top: 12px;
  border-top: 1px dashed #e2e8f0;
  font-size: 0.8125rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.01em;
}
.part-machine-assign .variant-settings-card__section-hint {
  margin: 0 0 8px;
  font-size: 0.75rem;
  line-height: 1.35;
  color: #64748b;
}
.part-machine-assign .variant-settings-card__section-hint code {
  font-size: 0.7rem;
  padding: 1px 4px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #334155;
}
.part-machine-assign .variant-settings-card__dim-rows {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 12px;
}
.part-machine-assign .variant-settings-card__dim-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.part-machine-assign .variant-settings-card__dim-row--inline {
  flex-direction: row;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: nowrap;
}
@media (max-width: 900px) {
  .part-machine-assign .variant-settings-card__dim-row--inline {
    flex-wrap: wrap;
  }
}
.part-machine-assign .variant-settings-card__dim-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
}
.part-machine-assign .variant-settings-card__dim-group--tol {
  flex: 0 0 110px;
  max-width: 130px;
}
@media (max-width: 900px) {
  .part-machine-assign .variant-settings-card__dim-group--tol {
    flex: 1 1 100px;
    max-width: none;
  }
}
.part-machine-assign .variant-settings-card__dim-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
}
.part-machine-assign .variant-settings-card__dim-inputs {
  display: flex;
  align-items: stretch;
  gap: 6px;
  width: 100%;
}
.part-machine-assign .variant-settings-card__dim-var {
  flex: 2 1;
  min-width: 0;
}
.part-machine-assign .variant-settings-card__dim-var input {
  text-align: left;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.part-machine-assign .variant-settings-card__dim-value {
  flex: 3 1;
  min-width: 0;
}
.part-machine-assign .variant-settings-card__dim-value--full {
  flex: 1 1 100%;
  max-width: 100%;
}
.part-machine-assign .variant-settings-card__hint {
  display: block;
  min-height: 1.125rem;
  margin: 0;
  padding-top: 2px;
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: #b45309;
}
.part-machine-assign .variant-settings-card__hint--hidden {
  visibility: hidden;
}
.part-machine-assign .variant-settings-card__final {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}
@keyframes assign-card-open {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.part-machine-assign .entry-card--error {
  border-color: #fecaca;
  background: #fef2f2;
}
.part-machine-assign .alert-inline {
  font-size: 0.8125rem;
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 12px;
}
.part-machine-assign .alert-inline--danger {
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
}
.part-machine-assign .part-tabs-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--m-border-color, #e2e8f0);
}
.part-machine-assign .part-tab {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 4px 0 10px;
  height: 30px;
  font-size: 0.8125rem;
  font-weight: 500;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #475569;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s, color 0.12s;
}
.part-machine-assign .part-tab--active {
  border-color: var(--m-primary, #2563eb);
  background: #eff6ff;
  color: var(--m-primary, #2563eb);
}
.part-machine-assign .part-tab--done:not(.part-machine-assign .part-tab--active) {
  border-color: #86efac;
  background: #f0fdf4;
  color: #15803d;
}
.part-machine-assign .part-tab--add {
  padding: 0 9px;
  color: #64748b;
}
.part-machine-assign .part-tab--add:hover {
  border-color: var(--m-primary, #2563eb);
  color: var(--m-primary, #2563eb);
  background: #eff6ff;
}
.part-machine-assign .part-tab__label {
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;
  white-space: nowrap;
}
.part-machine-assign .part-tab__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.1s, background 0.1s;
}
.part-machine-assign .part-tab__close:hover {
  opacity: 1;
  background: rgba(0, 0, 0, 0.08);
}
.part-machine-assign .assign-summary__collapse {
  border: 1px solid var(--m-border-color, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  margin-bottom: 10px;
  overflow: hidden;
}
.part-machine-assign .assign-summary__collapse:last-child {
  margin-bottom: 0;
}
.part-machine-assign .assign-summary__collapse--open .assign-summary__collapse-btn {
  border-bottom: 1px solid #f1f5f9;
}
.part-machine-assign .assign-summary__collapse-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border: none;
  background: #f8fafc;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s ease;
}
.part-machine-assign .assign-summary__collapse-btn:hover {
  background: #f1f5f9;
}
.part-machine-assign .assign-summary__collapse-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #334155;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  min-width: 0;
}
.part-machine-assign .assign-summary__collapse-meta {
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
  text-transform: none;
  letter-spacing: normal;
  padding: 2px 8px;
  border-radius: 999px;
  background: #e2e8f0;
}
.part-machine-assign .assign-summary__collapse-chevron {
  flex-shrink: 0;
  color: #94a3b8;
  display: flex;
  align-items: center;
}
.part-machine-assign .assign-summary__collapse-body {
  padding: 12px 14px 14px;
  animation: assign-card-open 0.18s ease;
}
.part-machine-assign .assign-summary__machine-inline {
  font-size: 0.9375rem;
  color: #0f172a;
}
.part-machine-assign .assign-summary__parts {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.part-machine-assign .assign-summary__part {
  border: 1px solid var(--m-border-color, #e2e8f0);
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.part-machine-assign .assign-summary__part--ok {
  border-color: #86efac;
}
.part-machine-assign .assign-summary__part--warn {
  border-color: #fde68a;
}
.part-machine-assign .assign-summary__part--open.assign-summary__part--ok {
  background: #fafefa;
}
.part-machine-assign .assign-summary__part--open.assign-summary__part--warn {
  background: #fffbeb;
}
.part-machine-assign .assign-summary__part-head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  border-bottom: 1px solid transparent;
}
.assign-summary__part--open .part-machine-assign .assign-summary__part-head {
  border-bottom-color: #f1f5f9;
}
.part-machine-assign .assign-summary__part-toggle {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}
.part-machine-assign .assign-summary__part-toggle:hover .assign-summary__part-title {
  color: var(--m-primary, #2563eb);
}
.part-machine-assign .assign-summary__part-body {
  padding: 12px 14px 14px;
  animation: assign-card-open 0.18s ease;
}
.part-machine-assign .assign-summary__part-body .assign-summary__collapse {
  margin-bottom: 8px;
}
.part-machine-assign .assign-summary__part-body .assign-summary__collapse:last-child {
  margin-bottom: 0;
}
.part-machine-assign .assign-summary__part-title-wrap {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}
.part-machine-assign .assign-summary__part-num {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8125rem;
  font-weight: 700;
  background: var(--m-primary, #2563eb);
  color: #fff;
}
.part-machine-assign .assign-summary__part-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 6px;
  transition: color 0.12s ease;
}
.part-machine-assign .assign-summary__part-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.part-machine-assign .assign-summary__part-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.part-machine-assign .assign-summary__status-select {
  min-width: 120px;
}
.part-machine-assign .assign-summary__list {
  padding-left: 1.1rem;
  font-size: 0.8125rem;
  color: #334155;
}
.part-machine-assign .assign-summary__list li + li {
  margin-top: 4px;
}
.part-machine-assign .assign-summary__variant-table-wrap {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.part-machine-assign .assign-summary__variant-table-wrap--scroll {
  height: 400px;
  max-height: 400px;
  overflow-y: auto;
}
.part-machine-assign .assign-summary__variant-table {
  width: 100%;
  font-size: 0.8125rem;
  border-collapse: collapse;
}
.part-machine-assign .assign-summary__variant-table th,
.part-machine-assign .assign-summary__variant-table td {
  padding: 8px 12px;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
}
.part-machine-assign .assign-summary__variant-table th {
  font-weight: 600;
  color: #64748b;
  background: #f8fafc;
}
.assign-summary__variant-table-wrap--scroll .part-machine-assign .assign-summary__variant-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: 0 1px 0 #e2e8f0;
}
.part-machine-assign .assign-summary__variant-table tbody tr:last-child td {
  border-bottom: none;
}

.part-machine-assign .assign-output-unused {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  overflow: hidden;
}
.part-machine-assign .assign-output-unused__toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}
.part-machine-assign .assign-output-unused__toggle:hover {
  background: #f1f5f9;
}
.part-machine-assign .assign-output-unused__title {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #64748b;
}
.part-machine-assign .assign-output-unused__count {
  font-size: 0.75rem;
  font-weight: 600;
  color: #94a3b8;
  padding: 1px 7px;
  border-radius: 999px;
  background: #e2e8f0;
}
.part-machine-assign .assign-output-unused__chevron {
  margin-left: auto;
  color: #94a3b8;
  display: flex;
  align-items: center;
}
.part-machine-assign .assign-output-unused__list {
  list-style: none;
  margin: 0;
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  border-top: 1px solid #e2e8f0;
}
@media (max-width: 520px) {
  .part-machine-assign .assign-output-unused__list {
    grid-template-columns: 1fr;
  }
}
.part-machine-assign .assign-output-unused__empty {
  margin: 0;
  padding: 10px 12px 12px;
  font-size: 0.8125rem;
  color: #94a3b8;
  border-top: 1px solid #e2e8f0;
}
.part-machine-assign .assign-output-unused__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #fff;
}
.part-machine-assign .assign-output-unused__label {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #64748b;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.part-machine-assign .assign-dnd-section {
  margin-top: 1rem;
}
.part-machine-assign .assign-dnd-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0;
  background: transparent;
  border: none;
}
.part-machine-assign .assign-dnd-toolbar__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.part-machine-assign .assign-dnd-toolbar__bulk {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  padding: 0 8px;
  background: transparent;
  border-radius: 8px;
}
.part-machine-assign .assign-dnd-toolbar__bulk-info {
  font-size: 0.8125rem;
  color: #1e40af;
  white-space: nowrap;
  margin: 0;
  padding: 0;
  line-height: 2.3744rem;
}
.part-machine-assign .assign-dnd-bulk-select {
  flex: 0 1 auto;
  min-width: 200px;
  max-width: 340px;
  margin-bottom: 0 !important;
  gap: 0 !important;
}
.part-machine-assign .assign-dnd-bulk-select > label {
  display: none;
}
.part-machine-assign .assign-dnd-bulk-select [class*=select-container__selected] {
  min-height: 2.3744rem !important;
  height: 2.3744rem !important;
  box-sizing: border-box;
}
.part-machine-assign .assign-dnd-bulk-select [class*=select-container__selected] [class*=selected--search] {
  height: 2.3744rem !important;
  min-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.part-machine-assign .assign-dnd-bulk-select [class*=select-container__selected] [class*=selected-list] {
  padding: 0 8px !important;
}
.part-machine-assign .assign-dnd-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  align-items: start;
}
@media (max-width: 700px) {
  .part-machine-assign .assign-dnd-panels {
    grid-template-columns: 1fr;
  }
}
.part-machine-assign .assign-dnd-panel {
  border: 1px solid var(--m-border-color, #e2e8f0);
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}
.part-machine-assign .assign-dnd-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
  gap: 10px;
}
.part-machine-assign .assign-dnd-panel__head-left {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}
.part-machine-assign .assign-dnd-panel__head-right {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-width: 140px;
  gap: 8px;
}
.part-machine-assign .assign-dnd-panel__title {
  font-size: 0.8125rem;
  font-weight: 700;
  color: #0f172a;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.part-machine-assign .assign-dnd-panel__count {
  font-size: 0.75rem;
  color: #94a3b8;
}
.part-machine-assign .assign-dnd-panel__content {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.part-machine-assign .assign-dnd-panel__body {
  padding: 10px;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.part-machine-assign .assign-dnd-panel__body--scroll {
  max-height: min(420px, 52vh);
  overflow-y: auto;
  overscroll-behavior: contain;
  flex-shrink: 0;
}
.part-machine-assign .assign-dnd-panel__pagination {
  flex-shrink: 0;
  padding: 8px 10px 10px;
  border-top: 1px solid #f1f5f9;
}
.part-machine-assign .assign-dnd-panel--inputs .assign-dnd-panel__body {
  background: #fafbfc;
}
.part-machine-assign .assign-dnd-panel--inputs .assign-dnd-panel__pagination {
  background: #fafbfc;
}
.part-machine-assign .assign-dnd-panel--outputs .assign-dnd-panel__body {
  background: #f8fafc;
}
.part-machine-assign .assign-dnd-panel--outputs .assign-dnd-panel__pagination {
  background: #f8fafc;
}
.part-machine-assign .assign-dnd-search {
  margin-bottom: 0 !important;
  max-width: 220px;
}
.part-machine-assign .assign-dnd-panel__head-actions {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-shrink: 0;
}
.part-machine-assign .assign-dnd-empty {
  font-size: 0.8125rem;
  color: #94a3b8;
  text-align: center;
  padding: 16px 8px;
  margin: 0;
}
.part-machine-assign .assign-dnd-link {
  background: none;
  border: none;
  padding: 0;
  color: var(--m-primary, #2563eb);
  cursor: pointer;
  font-size: inherit;
  text-decoration: underline;
}
.part-machine-assign .assign-dnd-link:hover {
  opacity: 0.8;
}
.part-machine-assign .assign-dnd-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: grab;
  transition: border-color 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
  -webkit-user-select: none;
          user-select: none;
}
.part-machine-assign .assign-dnd-item:hover {
  border-color: #93c5fd;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.08);
}
.part-machine-assign .assign-dnd-item:active {
  cursor: grabbing;
}
.part-machine-assign .assign-dnd-item--selected {
  background: #eff6ff;
  border-color: #3b82f6;
}
.part-machine-assign .assign-dnd-item--assigned {
  border-color: #86efac;
  background: #f0fdf4;
}
.part-machine-assign .assign-dnd-item__labels {
  display: flex;
  flex-direction: column;
  gap: 1px;
  flex: 1 1;
  min-width: 0;
}
.part-machine-assign .assign-dnd-item__entry {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.part-machine-assign .assign-dnd-item__variant {
  font-size: 0.75rem;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.part-machine-assign .assign-dnd-output {
  width: 100%;
  flex-shrink: 0;
}
.part-machine-assign .assign-dnd-output__card {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  background: #fff;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  min-height: 56px;
  transition: border-color 0.14s ease, background 0.14s ease, box-shadow 0.14s ease;
}
.part-machine-assign .assign-dnd-output--over .part-machine-assign .assign-dnd-output__card {
  border-color: var(--m-primary, #2563eb);
  background: #eff6ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}
.part-machine-assign .assign-dnd-output--assigned .part-machine-assign .assign-dnd-output__card {
  border-style: solid;
  border-color: #86efac;
  background: #f0fdf4;
}
.part-machine-assign .assign-dnd-output--assigned.assign-dnd-output--over .part-machine-assign .assign-dnd-output__card {
  border-color: var(--m-primary, #2563eb);
  background: #eff6ff;
}
.part-machine-assign .assign-dnd-output__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex: 0 0 auto;
}
.part-machine-assign .assign-dnd-output__label {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  flex: 1 1;
  min-width: 0;
  line-height: 1.35;
}
.part-machine-assign .assign-dnd-output__head-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}
.part-machine-assign .assign-dnd-output__clear, .part-machine-assign .assign-dnd-output__exclude {
  flex-shrink: 0;
}
.part-machine-assign .assign-dnd-output__metrics {
  width: 100%;
}
.part-machine-assign .assign-dnd-output__metrics--compact {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-top: 6px;
  border-top: 1px solid #e2e8f0;
}
.part-machine-assign .assign-dnd-output__weight-row {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  min-width: 0;
}
.part-machine-assign .assign-dnd-output__weight-label {
  font-size: 0.65rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.part-machine-assign .assign-dnd-output__weight-mini {
  font-size: 0.72rem;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
}
.part-machine-assign .assign-dnd-output__weight-mini--na {
  color: #94a3b8;
}
.part-machine-assign .assign-dnd-output__wastage-mini {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  flex-shrink: 0;
}
.part-machine-assign .assign-dnd-output__wastage-btn {
  width: 26px !important;
  height: 26px !important;
  min-width: 26px;
  padding: 0 !important;
}
.part-machine-assign .assign-dnd-output__wastage-badge {
  font-size: 0.7rem;
  font-weight: 600;
  color: #b45309;
  white-space: nowrap;
}
.part-machine-assign .assign-dnd-output__wastage-unit-hint {
  font-size: 0.65rem;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
}
.part-machine-assign .assign-dnd-output__chips {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  gap: 6px;
  width: 100%;
  min-width: 0;
  flex: 0 0 auto;
  position: static;
  margin: 0;
  padding: 0;
  border-top: none;
}
.part-machine-assign .assign-dnd-output--assigned .part-machine-assign .assign-dnd-output__chips {
  padding-top: 2px;
}
.part-machine-assign .assign-dnd-output__placeholder {
  font-size: 0.75rem;
  color: #94a3b8;
  font-style: italic;
  line-height: 1.4;
}
.part-machine-assign .assign-dnd-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 3px 8px 3px 10px;
  background: #fff;
  border: 1px solid #86efac;
  border-radius: 999px;
  font-size: 0.75rem;
  color: #166534;
  font-weight: 500;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.part-machine-assign .assign-dnd-chip__ratio-input {
  -webkit-user-select: text;
          user-select: text;
  pointer-events: auto;
  flex-shrink: 0;
}
.part-machine-assign .assign-dnd-chip__remove {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #16a34a;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: color 0.1s ease;
}
.part-machine-assign .assign-dnd-chip__remove:hover {
  color: #dc2626;
}
.part-machine-assign .entry-edit-variants {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 0;
  border: 1px solid var(--m-border-color, #e2e8f0);
  border-radius: 10px;
  background: #fafbfc;
  overflow: hidden;
}
.part-machine-assign .entry-edit-section {
  padding: 14px 16px;
}
.part-machine-assign .entry-edit-section + .part-machine-assign .entry-edit-section {
  border-top: 1px solid var(--m-border-color, #e2e8f0);
}
.part-machine-assign .entry-edit-section__title {
  margin: 0 0 4px;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #334155;
  text-transform: uppercase;
}
.part-machine-assign .entry-edit-section__desc {
  margin: 0 0 10px;
  font-size: 0.75rem;
  line-height: 1.45;
  color: #64748b;
}
.part-machine-assign .entry-edit-section__head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px 16px;
  margin-bottom: 12px;
}
.part-machine-assign .entry-edit-section--variants {
  background: #fff;
}
.part-machine-assign .entry-edit-default-ratio {
  max-width: 140px;
}
.part-machine-assign .entry-edit-stats {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  flex-shrink: 0;
}
.part-machine-assign .entry-edit-stats__total {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
}
.part-machine-assign .entry-edit-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 10px 14px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}
.part-machine-assign .entry-edit-toolbar__group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  min-width: 0;
}
.part-machine-assign .entry-edit-toolbar__group--bulk {
  padding-left: 14px;
  border-left: 1px solid #e2e8f0;
}
@media (max-width: 720px) {
  .part-machine-assign .entry-edit-toolbar__group--bulk {
    padding-left: 0;
    border-left: none;
    width: 100%;
  }
}
.part-machine-assign .entry-edit-toolbar__label {
  flex-shrink: 0;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
  margin-right: 2px;
}
.part-machine-assign .entry-edit-toolbar__ratio {
  width: 88px;
  flex-shrink: 0;
}
.part-machine-assign .entry-edit-empty {
  margin: 0;
  padding: 12px;
  text-align: center;
  font-size: 0.8125rem;
  color: #94a3b8;
  border: 1px dashed #e2e8f0;
  border-radius: 8px;
}
.part-machine-assign .assign-variant-table-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.part-machine-assign .assign-variant-table-pagination {
  flex-shrink: 0;
  padding-top: 2px;
}
.part-machine-assign .entry-variant-table-wrap {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.part-machine-assign .entry-variant-table-wrap--scroll {
  height: 400px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
  flex-shrink: 0;
}
.part-machine-assign .assign-metric {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  white-space: nowrap;
}
.part-machine-assign .assign-metric__value {
  font-weight: inherit;
}
.part-machine-assign .assign-metric__unit {
  font-size: 0.92em;
  font-weight: 600;
  color: #64748b;
}
.part-machine-assign .assign-qty-with-unit {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.part-machine-assign .assign-qty-with-unit__suffix {
  flex-shrink: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}
.part-machine-assign .assign-qty-with-unit--grid {
  justify-content: flex-end;
}
.part-machine-assign .entry-edit-toolbar__ratio-wrap.assign-qty-with-unit {
  flex: 0 1 140px;
  min-width: 100px;
}
.part-machine-assign .entry-variant-grid {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.part-machine-assign .entry-variant-grid col.entry-variant-grid__col-check {
  width: 52px;
}
.part-machine-assign .entry-variant-grid col.entry-variant-grid__col-qty {
  width: 128px;
}
.part-machine-assign .entry-variant-grid thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 8px 10px;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #64748b;
  text-align: left;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}
.part-machine-assign .entry-variant-grid thead th.text-end {
  text-align: right;
}
.part-machine-assign .entry-variant-grid thead th:first-child, .part-machine-assign .entry-variant-grid thead th:nth-child(2) {
  text-align: center;
}
.part-machine-assign .entry-variant-grid tbody td {
  padding: 8px 10px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f5f9;
}
.part-machine-assign .entry-variant-grid tbody tr:last-child td {
  border-bottom: none;
}
.part-machine-assign .entry-variant-grid__row--active td {
  background: #f8fafc;
}
.part-machine-assign .entry-variant-grid__row--bulk td:first-child {
  box-shadow: inset 3px 0 0 #3b82f6;
}
.part-machine-assign .entry-variant-grid__row--excluded td {
  opacity: 0.55;
  background: #fafafa;
}
.part-machine-assign .entry-variant-grid__cell-check {
  text-align: center;
  width: 52px;
}
.part-machine-assign .entry-variant-grid__check {
  display: inline-flex;
  justify-content: center;
  vertical-align: middle;
}
.part-machine-assign .entry-variant-grid__check [class*=checkbox-container] {
  margin: 0;
}
.part-machine-assign .entry-variant-grid__check [class*=checkbox-container] label:empty {
  display: none;
  width: 0;
  margin: 0;
  padding: 0;
}
.part-machine-assign .entry-variant-grid__cell-label {
  min-width: 0;
}
.part-machine-assign .entry-variant-grid__name {
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #334155;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.part-machine-assign .entry-variant-grid__code {
  display: block;
  font-size: 0.6875rem;
  color: #94a3b8;
  font-family: ui-monospace, monospace;
  line-height: 1.3;
}
.part-machine-assign .entry-variant-grid__cell-qty {
  text-align: right;
}
.part-machine-assign .entry-variant-grid__qty-input {
  width: 88px;
  max-width: 100%;
  margin-left: auto;
}

.part-machine-view .pm-view__topbar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px 0 6px;
  margin-bottom: 10px;
}
@media (max-width: 768px) {
  .part-machine-view .pm-view__topbar {
    grid-template-columns: 1fr;
    align-items: stretch;
  }
}
.part-machine-view .pm-view__machine {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid var(--m-border-color, #e2e8f0);
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fafc, #ffffff);
  min-width: 0;
}
.part-machine-view .pm-view__machine-label {
  font-size: 0.75rem;
  color: #64748b;
  line-height: 1.1;
}
.part-machine-view .pm-view__machine-value {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #0f172a;
}
.part-machine-view .pm-view__stats {
  display: flex;
  justify-content: flex-end;
}
.part-machine-view .pm-view__part {
  border: 1px solid var(--m-border-color, #e2e8f0);
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  margin-top: 12px;
}
.part-machine-view .pm-view__part--ok {
  border-color: #86efac;
}
.part-machine-view .pm-view__part--warn {
  border-color: #fde68a;
}
.part-machine-view .pm-view__part-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
}
.part-machine-view .pm-view__part-toggle {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
  padding: 0;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
}
.part-machine-view .pm-view__part-toggle:hover .pm-view__part-title {
  color: var(--m-primary, #2563eb);
}
.part-machine-view .pm-view__part-chevron {
  color: #94a3b8;
  margin-top: 2px;
  flex-shrink: 0;
}
.part-machine-view .pm-view__part-title-wrap {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.part-machine-view .pm-view__part-num {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8125rem;
  font-weight: 800;
  background: var(--m-primary, #2563eb);
  color: #fff;
}
.part-machine-view .pm-view__part-title {
  font-size: 0.95rem;
  font-weight: 800;
  color: #0f172a;
  transition: color 0.12s ease;
}
.part-machine-view .pm-view__part-sub {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 0.8125rem;
  margin-top: 4px;
}
.part-machine-view .pm-view__issues {
  font-weight: 700;
  color: #b45309;
  background: #fffbeb;
  border: 1px solid #fde68a;
  padding: 1px 8px;
  border-radius: 999px;
}
.part-machine-view .pm-view__part-badges {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.part-machine-view .pm-view__part-body {
  padding: 12px 16px 16px;
  background: #fff;
}
.part-machine-view .pm-view__tabs {
  margin-top: 6px;
}
.part-machine-view .pm-view__section {
  margin-top: 14px;
}
.part-machine-view .pm-view__section-head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 8px;
}
.part-machine-view .pm-view__table-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.part-machine-view .pm-view__pagination {
  flex-shrink: 0;
}
.part-machine-view .pm-view__table-wrap {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.part-machine-view .pm-view__table-wrap--scroll {
  height: 400px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
  flex-shrink: 0;
}
.part-machine-view .pm-view__table {
  width: 100%;
  font-size: 0.8125rem;
  border-collapse: collapse;
}
.part-machine-view .pm-view__table th,
.part-machine-view .pm-view__table td {
  padding: 9px 12px;
  text-align: left;
  border-bottom: 1px solid #f1f5f9;
  vertical-align: top;
}
.part-machine-view .pm-view__table th {
  font-weight: 800;
  color: #64748b;
  background: #f8fafc;
  white-space: nowrap;
}
.pm-view__table-wrap--scroll .part-machine-view .pm-view__table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: 0 1px 0 #e2e8f0;
}
.part-machine-view .pm-view__table tbody tr:last-child td {
  border-bottom: none;
}
.part-machine-view .pm-view__assign-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.part-machine-view .pm-view__assign-list--scroll {
  max-height: 96px;
  overflow-y: auto;
  padding-right: 4px;
}
.part-machine-view .pm-view__assign-list li {
  padding: 3px 8px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 6px;
  font-size: 0.75rem;
  color: #166534;
  word-break: break-word;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/PartMachines/PartMachines.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;AAAJ;AAGE;EACE,8BAAA;EACA,gDAAA;EACA,oDAAA;EACA,6CAAA;EACA,kEAAA;AADJ;AAIE;EACE,mBAAA;EACA,oBAAA;AAFJ;AAKE;EACE,aAAA;EACA,uBAAA;EACA,MAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;AAME;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAJJ;AAMI;EACE,aAAA;AAJN;AAQE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AANJ;AAQI;EACE,mBAAA;EACA,YAAA;AANN;AASI;EACE,gCAAA;AAPN;AAWE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AATJ;AAYE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAVJ;AAaE;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAXJ;AAcE;EACE,SAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAZJ;AAgBI;EACE,uCAAA;EACA,qCAAA;EACA,WAAA;AAdN;AAgBI;EACE,gCAAA;AAdN;AAmBI;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;AAjBN;AAmBI;EACE,cAAA;AAjBN;AAmBI;EACE,mBAAA;AAjBN;AAqBE;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gDAAA;AAnBJ;AAsBE;EACE,UAAA;AApBJ;AAuBE;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAvBJ;AA0BE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,0DACE;AAzBN;AA4BI;EACE,qBAAA;AA1BN;AA6BI;EACE,uCAAA;EACA,+CAAA;EACA,mBAAA;AA3BN;AA8BI;EACE,SAAA;EACA,YAAA;AA5BN;AA+BI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA7BN;AAgCI;EACE,kBAAA;EACA,cAAA;AA9BN;AAiCI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA/BN;AAkCI;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;AAhCN;AAoCE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EACA,uDAAA;AAlCJ;AAqCE;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AAnCJ;AAqCI;EACE,uCAAA;EACA,mBAAA;EACA,gCAAA;AAnCN;AAuCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,oDAAA;AArCJ;AAwCE;EACE,gDAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAtCJ;AAwCI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAtCN;AA0CE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxCJ;AA2CE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4CAAA;EACA,gBAAA;EACA,wDACE;AA1CN;AA6CI;EACE,6CAAA;AA3CN;AA8CI;EACE,qBAAA;EACA,mBAAA;AA5CN;AA+CI;EACE,aAAA;EACA,yCAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AA7CN;AA+CM;EACE,oCAAA;AA7CR;AAiDI;EACE,oCAAA;AA/CN;AAkDI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAhDN;AAkDM;EACE,mBAAA;EACA,WAAA;AAhDR;AAoDI;EACE,SAAA;EACA,YAAA;AAlDN;AAqDI;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AAnDN;AAsDI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AApDN;AAuDI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;AArDN;AAwDI;EACE,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAtDN;AAwDM;EACE,mBAAA;EACA,cAAA;AAtDR;AA0DI;EACE,yBAAA;EACA,6BAAA;EACA,qCAAA;AAxDN;AA2DI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;AAzDN;AA2DM;EANF;IAOI,0BAAA;EAxDN;AACF;AA2DI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAzDN;AA4DI;EACE,kBAAA;EACA,iBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;AA1DN;AA6DI;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AA3DN;AA6DM;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AA3DR;AA+DI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA7DN;AAgEI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA9DN;AAgEM;EACE,mBAAA;EACA,qBAAA;EACA,SAAA;EACA,iBAAA;AA9DR;AAgEQ;EANF;IAOI,eAAA;EA7DR;AACF;AAiEI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AA/DN;AAiEM;EACE,eAAA;EACA,gBAAA;AA/DR;AAiEQ;EAJF;IAKI,eAAA;IACA,eAAA;EA9DR;AACF;AAkEI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhEN;AAmEI;EACE,aAAA;EACA,oBAAA;EACA,QAAA;EACA,WAAA;AAjEN;AAoEI;EACE,SAAA;EACA,YAAA;AAlEN;AAoEM;EACE,gBAAA;EACA,gBAAA;EACA,sBAAA;AAlER;AAsEI;EACE,SAAA;EACA,YAAA;AApEN;AAsEM;EACE,cAAA;EACA,eAAA;AApER;AAwEI;EACE,cAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AAtEN;AAwEM;EACE,kBAAA;AAtER;AA0EI;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;AAxEN;AA4EE;EACE;IACE,UAAA;IACA,2BAAA;EA1EJ;EA4EE;IACE,UAAA;IACA,wBAAA;EA1EJ;AACF;AA6EE;EACE,qBAAA;EACA,mBAAA;AA3EJ;AA8EE;EACE,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA5EJ;AA8EI;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;AA5EN;AAkFE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,oBAAA;EACA,uDAAA;AAhFJ;AAmFE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,6DACE;AAlFN;AAsFI;EACE,uCAAA;EACA,mBAAA;EACA,gCAAA;AApFN;AAuFI;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AArFN;AAwFI;EACE,cAAA;EACA,cAAA;AAtFN;AAwFM;EACE,uCAAA;EACA,gCAAA;EACA,mBAAA;AAtFR;AA0FI;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAxFN;AA2FI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,yCACE;AA1FR;AA6FM;EACE,UAAA;EACA,+BAAA;AA3FR;AAmGI;EACE,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAjGN;AAmGM;EACE,gBAAA;AAjGR;AAqGQ;EACE,gCAAA;AAnGV;AAwGI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAtGN;AAwGM;EACE,mBAAA;AAtGR;AA0GI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AAxGN;AA2GI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AAzGN;AA4GI;EACE,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AA1GN;AA6GI;EACE,uBAAA;EACA,sCAAA;AA3GN;AA8GI;EACE,oBAAA;EACA,cAAA;AA5GN;AA+GI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7GN;AAgHI;EACE,gDAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AA9GN;AAgHM;EACE,qBAAA;AA9GR;AAiHM;EACE,qBAAA;AA/GR;AAkHM;EACE,mBAAA;AAhHR;AAmHM;EACE,mBAAA;AAjHR;AAqHI;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;AAnHN;AAqHM;EACE,4BAAA;AAnHR;AAuHI;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AArHN;AAuHM;EACE,gCAAA;AArHR;AAyHI;EACE,uBAAA;EACA,sCAAA;AAvHN;AAyHM;EACE,kBAAA;AAvHR;AAyHQ;EACE,gBAAA;AAvHV;AA4HI;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AA1HN;AA6HI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;AA3HN;AA8HI;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;AA5HN;AA+HI;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA7HN;AAgII;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA9HN;AAiII;EACE,gBAAA;AA/HN;AAkII;EACE,oBAAA;EACA,oBAAA;EACA,cAAA;AAhIN;AAkIM;EACE,eAAA;AAhIR;AAoII;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;AAlIN;AAoIM;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAlIR;AAsII;EACE,WAAA;EACA,oBAAA;EACA,yBAAA;AApIN;AAsIM;;EAEE,iBAAA;EACA,gBAAA;EACA,gCAAA;AApIR;AAuIM;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AArIR;AAwIM;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,2BAAA;AAtIR;AAyIM;EACE,mBAAA;AAvIR;;AAgJE;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA7IJ;AA+II;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA7IN;AA+IM;EACE,mBAAA;AA7IR;AAiJI;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;AA/IN;AAkJI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AAhJN;AAmJI;EACE,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAjJN;AAoJI;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,gDAAA;EACA,QAAA;EACA,6BAAA;AAlJN;AAoJM;EATF;IAUI,0BAAA;EAjJN;AACF;AAoJI;EACE,SAAA;EACA,uBAAA;EACA,oBAAA;EACA,cAAA;EACA,6BAAA;AAlJN;AAqJI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;AAnJN;AAsJI;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AApJN;AAwJE;EACE,gBAAA;AAtJJ;AAyJE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;AAvJJ;AAyJI;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAvJN;AA0JI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;AAxJN;AA2JI;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;AAzJN;AA6JE;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AA3JJ;AA6JI;EACE,aAAA;AA3JN;AA8JI;EACE,gCAAA;EACA,4BAAA;EACA,sBAAA;AA5JN;AA8JM;EACE,4BAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;AA5JR;AA+JM;EACE,yBAAA;AA7JR;AAkKE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAhKJ;AAkKI;EANF;IAOI,0BAAA;EA/JJ;AACF;AAkKE;EACE,gDAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAhKJ;AAkKI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;EACA,SAAA;AAhKN;AAmKI;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AAjKN;AAoKI;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;AAlKN;AAqKI;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAnKN;AAsKI;EACE,kBAAA;EACA,cAAA;AApKN;AAuKI;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AArKN;AAwKI;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAtKN;AAwKM;EACE,4BAAA;EACA,gBAAA;EACA,4BAAA;EACA,cAAA;AAtKR;AA0KI;EACE,cAAA;EACA,sBAAA;EACA,6BAAA;AAxKN;AA4KM;EACE,mBAAA;AA1KR;AA6KM;EACE,mBAAA;AA3KR;AAgLM;EACE,mBAAA;AA9KR;AAiLM;EACE,mBAAA;AA/KR;AAoLE;EACE,2BAAA;EACA,gBAAA;AAlLJ;AAqLE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;AAnLJ;AAsLE;EACE,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;AApLJ;AAuLE;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AArLJ;AAuLI;EACE,YAAA;AArLN;AAyLE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iFACE;EAGF,yBAAA;UAAA,iBAAA;AA1LJ;AA4LI;EACE,qBAAA;EACA,6CAAA;AA1LN;AA6LI;EACE,gBAAA;AA3LN;AA8LI;EACE,mBAAA;EACA,qBAAA;AA5LN;AA+LI;EACE,qBAAA;EACA,mBAAA;AA7LN;AAgMI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AA9LN;AAiMI;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA/LN;AAkMI;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhMN;AAoME;EACE,WAAA;EACA,cAAA;AAlMJ;AAoMI;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,iFACE;AAnMR;AAwMI;EACE,uCAAA;EACA,mBAAA;EACA,8CAAA;AAtMN;AAyMI;EACE,mBAAA;EACA,qBAAA;EACA,mBAAA;AAvMN;AA0MI;EACE,uCAAA;EACA,mBAAA;AAxMN;AA2MI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,cAAA;AAzMN;AA4MI;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;AA1MN;AA6MI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AA3MN;AA8MI;EAEE,cAAA;AA7MN;AAgNI;EACE,WAAA;AA9MN;AAgNM;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;AA9MR;AAkNI;EACE,oBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AAhNN;AAmNI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAjNN;AAoNI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAlNN;AAoNM;EACE,cAAA;AAlNR;AAsNI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,cAAA;AApNN;AAuNI;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AArNN;AAwNI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAtNN;AAyNI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAvNN;AA0NI;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAxNN;AA2NI;EACE,gBAAA;AAzNN;AA4NI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA1NN;AA8NE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA5NJ;AA8NI;EACE,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,cAAA;AA5NN;AA+NI;EACE,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,2BAAA;AA7NN;AA+NM;EACE,cAAA;AA7NR;AAkOE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,gDAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAhOJ;AAmOE;EACE,kBAAA;AAjOJ;AAmOI;EACE,oDAAA;AAjON;AAoOI;EACE,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;AAlON;AAqOI;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAnON;AAsOI;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;AApON;AAuOI;EACE,gBAAA;AArON;AAyOE;EACE,gBAAA;AAvOJ;AA0OE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAxOJ;AA0OI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAxON;AA4OE;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA1OJ;AA4OI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AA1ON;AA4OM;EACE,kBAAA;EACA,8BAAA;AA1OR;AA4OQ;EAJF;IAKI,eAAA;IACA,iBAAA;IACA,WAAA;EAzOR;AACF;AA6OI;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;AA3ON;AA8OI;EACE,WAAA;EACA,cAAA;AA5ON;AAgPE;EACE,SAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;AA9OJ;AAiPE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA/OJ;AAkPE;EACE,cAAA;EACA,gBAAA;AAhPJ;AAmPE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAjPJ;AAmPI;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAjPN;AAqPE;EACE,oBAAA;EACA,qBAAA;EACA,QAAA;EACA,mBAAA;AAnPJ;AAqPI;EACE,oBAAA;AAnPN;AAsPI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AApPN;AAwPE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAtPJ;AAwPI;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAtPN;AAyPI;EACE,yBAAA;AAvPN;AA2PE;EACE,eAAA;EACA,gBAAA;AAzPJ;AA4PE;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AA1PJ;AA4PI;EACE,WAAA;AA1PN;AA6PI;EACE,YAAA;AA3PN;AA8PI;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;AA5PN;AA8PM;EACE,iBAAA;AA5PR;AA+PM;EAEE,kBAAA;AA9PR;AAkQI;EACE,iBAAA;EACA,sBAAA;EACA,gCAAA;AAhQN;AAmQI;EACE,mBAAA;AAjQN;AAoQI;EACE,mBAAA;AAlQN;AAqQI;EACE,iCAAA;AAnQN;AAsQI;EACE,aAAA;EACA,mBAAA;AApQN;AAuQI;EACE,kBAAA;EACA,WAAA;AArQN;AAwQI;EACE,oBAAA;EACA,uBAAA;EACA,sBAAA;AAtQN;AAwQM;EACE,SAAA;AAtQR;AAwQQ;EACE,aAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAtQV;AA2QI;EACE,YAAA;AAzQN;AA4QI;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1QN;AA6QI;EACE,cAAA;EACA,oBAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;AA3QN;AA8QI;EACE,iBAAA;AA5QN;AA+QI;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AA7QN;;AAwRE;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AArRJ;AAuRI;EARF;IASI,0BAAA;IACA,oBAAA;EApRJ;AACF;AAuRE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gDAAA;EACA,mBAAA;EACA,qDAAA;EACA,YAAA;AArRJ;AAwRE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAtRJ;AAyRE;EACE,oBAAA;EACA,gBAAA;EACA,cAAA;AAvRJ;AA0RE;EACE,aAAA;EACA,yBAAA;AAxRJ;AA2RE;EACE,gDAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4CAAA;EACA,gBAAA;AAzRJ;AA2RI;EACE,qBAAA;AAzRN;AA2RI;EACE,qBAAA;AAzRN;AA6RE;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AA3RJ;AA8RE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AA5RJ;AA8RI;EACE,gCAAA;AA5RN;AAgSE;EACE,cAAA;EACA,eAAA;EACA,cAAA;AA9RJ;AAiSE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AA/RJ;AAkSE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;AAhSJ;AAmSE;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;AAjSJ;AAoSE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;AAlSJ;AAqSE;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;AAnSJ;AAsSE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AApSJ;AAuSE;EACE,uBAAA;EACA,gBAAA;AArSJ;AAwSE;EACE,eAAA;AAtSJ;AAySE;EACE,gBAAA;AAvSJ;AA0SE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAxSJ;AA2SE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAzSJ;AA4SE;EACE,cAAA;AA1SJ;AA6SE;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;AA3SJ;AA6SI;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA3SN;AA+SE;EACE,WAAA;EACA,oBAAA;EACA,yBAAA;AA7SJ;AA+SI;;EAEE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AA7SN;AAgTI;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AA9SN;AAiTI;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,2BAAA;AA/SN;AAkTI;EACE,mBAAA;AAhTN;AAoTE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAlTJ;AAoTI;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAlTN;AAqTI;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AAnTN","sourcesContent":[".part-machine-assign {\n  .assign-page-body {\n    height: auto !important;\n  }\n\n  .assign-wizard-card {\n    padding: 1.25rem 1.5rem 1.5rem;\n    background: var(--m-card-background-color, #fff);\n    border: 1px solid var(--m-border-card-file, #e2e8f0);\n    border-radius: var(--m-border-radius-md, 8px);\n    box-shadow: var(--m-box-shadow-car, 0 1px 3px rgba(0, 0, 0, 0.08));\n  }\n\n  .assign-wizard-card .assign-footer {\n    margin-top: 1.25rem;\n    padding-top: 1.25rem;\n  }\n\n  .assign-stepper {\n    display: flex;\n    align-items: flex-start;\n    gap: 0;\n    margin-bottom: 8px;\n    padding: 0;\n    list-style: none;\n    overflow-x: auto;\n  }\n\n  .assign-stepper__item {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    min-width: 0;\n\n    &:last-child .assign-stepper__connector {\n      display: none;\n    }\n  }\n\n  .assign-stepper__btn {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    min-width: 0;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.5;\n    }\n\n    &:not(:disabled):hover .assign-stepper__label {\n      color: var(--m-primary, #2563eb);\n    }\n  }\n\n  .assign-stepper__top {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .assign-stepper__num {\n    flex-shrink: 0;\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75rem;\n    font-weight: 700;\n    border: 2px solid #cbd5e1;\n    color: #64748b;\n    background: #fff;\n  }\n\n  .assign-stepper__label {\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: #64748b;\n    white-space: nowrap;\n  }\n\n  .assign-stepper__connector {\n    flex: 1;\n    height: 2px;\n    min-width: 16px;\n    margin: 0 12px;\n    margin-top: 14px;\n    background: #e2e8f0;\n  }\n\n  .assign-stepper__item--active {\n    .assign-stepper__num {\n      border-color: var(--m-primary, #2563eb);\n      background: var(--m-primary, #2563eb);\n      color: #fff;\n    }\n    .assign-stepper__label {\n      color: var(--m-primary, #2563eb);\n    }\n  }\n\n  .assign-stepper__item--done {\n    .assign-stepper__num {\n      border-color: #16a34a;\n      background: #16a34a;\n      color: #fff;\n    }\n    .assign-stepper__label {\n      color: #15803d;\n    }\n    .assign-stepper__connector {\n      background: #86efac;\n    }\n  }\n\n  .assign-step-hint {\n    font-size: 0.8125rem;\n    color: #64748b;\n    margin-bottom: 20px;\n    padding: 10px 14px;\n    background: #f8fafc;\n    border-radius: 6px;\n    border-left: 3px solid var(--m-primary, #2563eb);\n  }\n\n  .assign-section {\n    padding: 0;\n  }\n\n  .assign-section__title {\n    font-size: 0.9375rem;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 4px;\n  }\n\n  .assign-section__desc {\n    font-size: 0.8125rem;\n    color: #64748b;\n    margin-bottom: 16px;\n  }\n\n  .entry-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .entry-card {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 14px 16px;\n    border: 1px solid var(--m-border-color, #e2e8f0);\n    border-radius: 8px;\n    background: #fff;\n    cursor: pointer;\n    transition:\n      border-color 0.15s ease,\n      box-shadow 0.15s ease;\n\n    &:hover {\n      border-color: #94a3b8;\n    }\n\n    &--active {\n      border-color: var(--m-primary, #2563eb);\n      box-shadow: 0 0 0 1px var(--m-primary, #2563eb);\n      background: #f8fafc;\n    }\n\n    &__main {\n      flex: 1;\n      min-width: 0;\n    }\n\n    &__title {\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: #334155;\n      margin-bottom: 4px;\n    }\n\n    &__meta {\n      font-size: 0.75rem;\n      color: #64748b;\n    }\n\n    &__actions {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      flex-shrink: 0;\n    }\n\n    &__form {\n      margin-top: 12px;\n      padding-top: 12px;\n      border-top: 1px solid #e2e8f0;\n    }\n  }\n\n  .entry-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin-bottom: 16px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid var(--m-border-color, #e2e8f0);\n  }\n\n  .entry-tab {\n    padding: 6px 12px;\n    font-size: 0.8125rem;\n    font-weight: 500;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #f8fafc;\n    color: #475569;\n    cursor: pointer;\n\n    &--active {\n      border-color: var(--m-primary, #2563eb);\n      background: #eff6ff;\n      color: var(--m-primary, #2563eb);\n    }\n  }\n\n  .assign-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    margin-top: 24px;\n    padding-top: 20px;\n    border-top: 1px solid var(--m-border-color, #e2e8f0);\n  }\n\n  .variant-panel {\n    border: 1px solid var(--m-border-color, #e2e8f0);\n    border-radius: 8px;\n    padding: 14px 16px;\n    background: #fafbfc;\n\n    &__toolbar {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 10px 14px;\n      padding: 8px 10px;\n      border-radius: 6px;\n      background: #fff;\n      border: 1px solid #e2e8f0;\n    }\n  }\n\n  .variant-settings-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .variant-settings-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n    overflow: hidden;\n    transition:\n      border-color 0.2s ease,\n      box-shadow 0.2s ease;\n\n    &--open {\n      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);\n    }\n\n    &--done {\n      border-color: #86efac;\n      background: #f0fdf4;\n    }\n\n    &__header {\n      display: grid;\n      grid-template-columns: auto 1fr auto auto;\n      align-items: center;\n      gap: 12px;\n      width: 100%;\n      padding: 12px 14px;\n      border: 0;\n      background: transparent;\n      text-align: left;\n      cursor: pointer;\n\n      &:hover {\n        background: rgba(241, 245, 249, 0.6);\n      }\n    }\n\n    &--done &__header:hover {\n      background: rgba(220, 252, 231, 0.5);\n    }\n\n    &__status {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 36px;\n      height: 36px;\n      border-radius: 10px;\n      background: #f1f5f9;\n      color: #64748b;\n      font-size: 0.875rem;\n      font-weight: 600;\n      flex-shrink: 0;\n\n      &--done {\n        background: #22c55e;\n        color: #fff;\n      }\n    }\n\n    &__title {\n      flex: 1;\n      min-width: 0;\n    }\n\n    &__label {\n      font-size: 0.875rem;\n      font-weight: 600;\n      color: #0f172a;\n    }\n\n    &__meta {\n      display: block;\n      font-size: 0.75rem;\n      color: #64748b;\n      margin-top: 2px;\n    }\n\n    &__chevron {\n      color: #94a3b8;\n      display: flex;\n      align-items: center;\n    }\n\n    &__badge {\n      font-size: 0.6875rem;\n      font-weight: 600;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n      padding: 4px 10px;\n      border-radius: 999px;\n      background: #fef3c7;\n      color: #b45309;\n      flex-shrink: 0;\n\n      &--done {\n        background: #dcfce7;\n        color: #15803d;\n      }\n    }\n\n    &__body {\n      padding: 0 14px 14px 62px;\n      border-top: 1px solid #f1f5f9;\n      animation: assign-card-open 0.2s ease;\n    }\n\n    &__fields {\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 12px;\n      padding-top: 14px;\n\n      @media (max-width: 576px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    &__field {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n    }\n\n    &__section-title {\n      margin: 16px 0 4px;\n      padding-top: 12px;\n      border-top: 1px dashed #e2e8f0;\n      font-size: 0.8125rem;\n      font-weight: 700;\n      color: #0f172a;\n      letter-spacing: 0.01em;\n    }\n\n    &__section-hint {\n      margin: 0 0 8px;\n      font-size: 0.75rem;\n      line-height: 1.35;\n      color: #64748b;\n\n      code {\n        font-size: 0.7rem;\n        padding: 1px 4px;\n        border-radius: 4px;\n        background: #f1f5f9;\n        color: #334155;\n      }\n    }\n\n    &__dim-rows {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      margin-bottom: 12px;\n    }\n\n    &__dim-row {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      &--inline {\n        flex-direction: row;\n        align-items: flex-end;\n        gap: 12px;\n        flex-wrap: nowrap;\n\n        @media (max-width: 900px) {\n          flex-wrap: wrap;\n        }\n      }\n    }\n\n    &__dim-group {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      flex: 1 1 0;\n      min-width: 0;\n\n      &--tol {\n        flex: 0 0 110px;\n        max-width: 130px;\n\n        @media (max-width: 900px) {\n          flex: 1 1 100px;\n          max-width: none;\n        }\n      }\n    }\n\n    &__dim-label {\n      font-size: 0.75rem;\n      font-weight: 600;\n      color: #334155;\n      white-space: nowrap;\n    }\n\n    &__dim-inputs {\n      display: flex;\n      align-items: stretch;\n      gap: 6px;\n      width: 100%;\n    }\n\n    &__dim-var {\n      flex: 2 1 0; // ~40% of row\n      min-width: 0;\n\n      input {\n        text-align: left;\n        font-weight: 600;\n        letter-spacing: 0.02em;\n      }\n    }\n\n    &__dim-value {\n      flex: 3 1 0; // ~60% of row\n      min-width: 0;\n\n      &--full {\n        flex: 1 1 100%;\n        max-width: 100%;\n      }\n    }\n\n    &__hint {\n      display: block;\n      min-height: 1.125rem;\n      margin: 0;\n      padding-top: 2px;\n      font-size: 0.75rem;\n      line-height: 1.125rem;\n      color: #b45309;\n\n      &--hidden {\n        visibility: hidden;\n      }\n    }\n\n    &__final {\n      margin-top: 14px;\n      padding-top: 14px;\n      border-top: 1px dashed #e2e8f0;\n    }\n  }\n\n  @keyframes assign-card-open {\n    from {\n      opacity: 0;\n      transform: translateY(-4px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n\n  .entry-card--error {\n    border-color: #fecaca;\n    background: #fef2f2;\n  }\n\n  .alert-inline {\n    font-size: 0.8125rem;\n    border-radius: 6px;\n    padding: 10px 14px;\n    margin-top: 12px;\n\n    &--danger {\n      color: #b91c1c;\n      background: #fef2f2;\n      border: 1px solid #fecaca;\n    }\n  }\n\n  // ---- Multi-part tab bar ----\n\n  .part-tabs-bar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 16px;\n    padding-bottom: 14px;\n    border-bottom: 1px solid var(--m-border-color, #e2e8f0);\n  }\n\n  .part-tab {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 0 4px 0 10px;\n    height: 30px;\n    font-size: 0.8125rem;\n    font-weight: 500;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #f8fafc;\n    color: #475569;\n    cursor: pointer;\n    transition:\n      border-color 0.12s,\n      background 0.12s,\n      color 0.12s;\n\n    &--active {\n      border-color: var(--m-primary, #2563eb);\n      background: #eff6ff;\n      color: var(--m-primary, #2563eb);\n    }\n\n    &--done:not(&--active) {\n      border-color: #86efac;\n      background: #f0fdf4;\n      color: #15803d;\n    }\n\n    &--add {\n      padding: 0 9px;\n      color: #64748b;\n\n      &:hover {\n        border-color: var(--m-primary, #2563eb);\n        color: var(--m-primary, #2563eb);\n        background: #eff6ff;\n      }\n    }\n\n    &__label {\n      display: flex;\n      align-items: center;\n      padding: 0;\n      border: none;\n      background: transparent;\n      color: inherit;\n      font: inherit;\n      cursor: pointer;\n      white-space: nowrap;\n    }\n\n    &__close {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 18px;\n      height: 18px;\n      padding: 0;\n      border: none;\n      border-radius: 4px;\n      background: transparent;\n      color: inherit;\n      cursor: pointer;\n      opacity: 0.6;\n      transition:\n        opacity 0.1s,\n        background 0.1s;\n\n      &:hover {\n        opacity: 1;\n        background: rgba(0, 0, 0, 0.08);\n      }\n    }\n  }\n\n  // ---- Step 5: assignment summary ----\n\n  .assign-summary {\n    &__collapse {\n      border: 1px solid var(--m-border-color, #e2e8f0);\n      border-radius: 8px;\n      background: #fff;\n      margin-bottom: 10px;\n      overflow: hidden;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      &--open {\n        .assign-summary__collapse-btn {\n          border-bottom: 1px solid #f1f5f9;\n        }\n      }\n    }\n\n    &__collapse-btn {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 12px;\n      width: 100%;\n      padding: 12px 14px;\n      border: none;\n      background: #f8fafc;\n      cursor: pointer;\n      text-align: left;\n      transition: background 0.12s ease;\n\n      &:hover {\n        background: #f1f5f9;\n      }\n    }\n\n    &__collapse-title {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      font-size: 0.8125rem;\n      font-weight: 600;\n      color: #334155;\n      text-transform: uppercase;\n      letter-spacing: 0.02em;\n      min-width: 0;\n    }\n\n    &__collapse-meta {\n      font-size: 0.75rem;\n      font-weight: 500;\n      color: #64748b;\n      text-transform: none;\n      letter-spacing: normal;\n      padding: 2px 8px;\n      border-radius: 999px;\n      background: #e2e8f0;\n    }\n\n    &__collapse-chevron {\n      flex-shrink: 0;\n      color: #94a3b8;\n      display: flex;\n      align-items: center;\n    }\n\n    &__collapse-body {\n      padding: 12px 14px 14px;\n      animation: assign-card-open 0.18s ease;\n    }\n\n    &__machine-inline {\n      font-size: 0.9375rem;\n      color: #0f172a;\n    }\n\n    &__parts {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n    }\n\n    &__part {\n      border: 1px solid var(--m-border-color, #e2e8f0);\n      border-radius: 10px;\n      background: #fff;\n      overflow: hidden;\n\n      &--ok {\n        border-color: #86efac;\n      }\n\n      &--warn {\n        border-color: #fde68a;\n      }\n\n      &--open.assign-summary__part--ok {\n        background: #fafefa;\n      }\n\n      &--open.assign-summary__part--warn {\n        background: #fffbeb;\n      }\n    }\n\n    &__part-head {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: flex-start;\n      justify-content: space-between;\n      gap: 12px;\n      padding: 12px 14px;\n      background: #f8fafc;\n      border-bottom: 1px solid transparent;\n\n      .assign-summary__part--open & {\n        border-bottom-color: #f1f5f9;\n      }\n    }\n\n    &__part-toggle {\n      display: flex;\n      align-items: flex-start;\n      gap: 8px;\n      flex: 1;\n      min-width: 0;\n      padding: 0;\n      border: none;\n      background: transparent;\n      cursor: pointer;\n      text-align: left;\n\n      &:hover .assign-summary__part-title {\n        color: var(--m-primary, #2563eb);\n      }\n    }\n\n    &__part-body {\n      padding: 12px 14px 14px;\n      animation: assign-card-open 0.18s ease;\n\n      .assign-summary__collapse {\n        margin-bottom: 8px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    &__part-title-wrap {\n      display: flex;\n      align-items: flex-start;\n      gap: 12px;\n      min-width: 0;\n    }\n\n    &__part-num {\n      flex-shrink: 0;\n      width: 28px;\n      height: 28px;\n      border-radius: 8px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 0.8125rem;\n      font-weight: 700;\n      background: var(--m-primary, #2563eb);\n      color: #fff;\n    }\n\n    &__part-title {\n      font-size: 0.9375rem;\n      font-weight: 600;\n      color: #0f172a;\n      margin: 0 0 6px;\n      transition: color 0.12s ease;\n    }\n\n    &__part-badges {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 6px;\n    }\n\n    &__part-actions {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 8px;\n      flex-shrink: 0;\n    }\n\n    &__status-select {\n      min-width: 120px;\n    }\n\n    &__list {\n      padding-left: 1.1rem;\n      font-size: 0.8125rem;\n      color: #334155;\n\n      li + li {\n        margin-top: 4px;\n      }\n    }\n\n    &__variant-table-wrap {\n      overflow-x: auto;\n      border: 1px solid #e2e8f0;\n      border-radius: 8px;\n\n      &--scroll {\n        height: 400px;\n        max-height: 400px;\n        overflow-y: auto;\n      }\n    }\n\n    &__variant-table {\n      width: 100%;\n      font-size: 0.8125rem;\n      border-collapse: collapse;\n\n      th,\n      td {\n        padding: 8px 12px;\n        text-align: left;\n        border-bottom: 1px solid #f1f5f9;\n      }\n\n      th {\n        font-weight: 600;\n        color: #64748b;\n        background: #f8fafc;\n      }\n\n      .assign-summary__variant-table-wrap--scroll & thead th {\n        position: sticky;\n        top: 0;\n        z-index: 1;\n        box-shadow: 0 1px 0 #e2e8f0;\n      }\n\n      tbody tr:last-child td {\n        border-bottom: none;\n      }\n    }\n  }\n}\n\n// ---- Drag-drop assignment (Step 3) ----\n\n.part-machine-assign {\n  .assign-output-unused {\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #f8fafc;\n    overflow: hidden;\n\n    &__toggle {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      width: 100%;\n      padding: 10px 12px;\n      border: none;\n      background: transparent;\n      cursor: pointer;\n      text-align: left;\n\n      &:hover {\n        background: #f1f5f9;\n      }\n    }\n\n    &__title {\n      font-size: 0.8125rem;\n      font-weight: 600;\n      color: #64748b;\n    }\n\n    &__count {\n      font-size: 0.75rem;\n      font-weight: 600;\n      color: #94a3b8;\n      padding: 1px 7px;\n      border-radius: 999px;\n      background: #e2e8f0;\n    }\n\n    &__chevron {\n      margin-left: auto;\n      color: #94a3b8;\n      display: flex;\n      align-items: center;\n    }\n\n    &__list {\n      list-style: none;\n      margin: 0;\n      padding: 10px;\n      display: grid;\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      gap: 8px;\n      border-top: 1px solid #e2e8f0;\n\n      @media (max-width: 520px) {\n        grid-template-columns: 1fr;\n      }\n    }\n\n    &__empty {\n      margin: 0;\n      padding: 10px 12px 12px;\n      font-size: 0.8125rem;\n      color: #94a3b8;\n      border-top: 1px solid #e2e8f0;\n    }\n\n    &__item {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 8px;\n      padding: 8px 10px;\n      border: 1px dashed #cbd5e1;\n      border-radius: 8px;\n      background: #fff;\n    }\n\n    &__label {\n      font-size: 0.8125rem;\n      font-weight: 500;\n      color: #64748b;\n      min-width: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .assign-dnd-section {\n    margin-top: 1rem;\n  }\n\n  .assign-dnd-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 10px;\n    padding: 0;\n    background: transparent;\n    border: none;\n\n    &__actions {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n      align-items: center;\n    }\n\n    &__bulk {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 8px;\n      margin-left: auto;\n      padding: 0 8px;\n      background: transparent;\n      border-radius: 8px;\n    }\n\n    &__bulk-info {\n      font-size: 0.8125rem;\n      color: #1e40af;\n      white-space: nowrap;\n      margin: 0;\n      padding: 0;\n      line-height: 2.3744rem;\n    }\n  }\n\n  .assign-dnd-bulk-select {\n    flex: 0 1 auto;\n    min-width: 200px;\n    max-width: 340px;\n    margin-bottom: 0 !important;\n    gap: 0 !important;\n\n    > label {\n      display: none;\n    }\n\n    [class*=\"select-container__selected\"] {\n      min-height: 2.3744rem !important;\n      height: 2.3744rem !important;\n      box-sizing: border-box;\n\n      [class*=\"selected--search\"] {\n        height: 2.3744rem !important;\n        min-height: 0;\n        padding-top: 0;\n        padding-bottom: 0;\n      }\n\n      [class*=\"selected-list\"] {\n        padding: 0 8px !important;\n      }\n    }\n  }\n\n  .assign-dnd-panels {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 14px;\n    align-items: start;\n\n    @media (max-width: 700px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .assign-dnd-panel {\n    border: 1px solid var(--m-border-color, #e2e8f0);\n    border-radius: 12px;\n    background: #fff;\n    overflow: hidden;\n\n    &__header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: 10px 14px;\n      background: #f8fafc;\n      border-bottom: 1px solid #f1f5f9;\n      gap: 10px;\n    }\n\n    &__head-left {\n      display: flex;\n      align-items: baseline;\n      gap: 8px;\n      min-width: 0;\n    }\n\n    &__head-right {\n      flex: 1;\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      min-width: 140px;\n      gap: 8px;\n    }\n\n    &__title {\n      font-size: 0.8125rem;\n      font-weight: 700;\n      color: #0f172a;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n    }\n\n    &__count {\n      font-size: 0.75rem;\n      color: #94a3b8;\n    }\n\n    &__content {\n      display: flex;\n      flex-direction: column;\n      min-height: 0;\n    }\n\n    &__body {\n      padding: 10px;\n      min-height: 120px;\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n\n      &--scroll {\n        max-height: min(420px, 52vh);\n        overflow-y: auto;\n        overscroll-behavior: contain;\n        flex-shrink: 0;\n      }\n    }\n\n    &__pagination {\n      flex-shrink: 0;\n      padding: 8px 10px 10px;\n      border-top: 1px solid #f1f5f9;\n    }\n\n    &--inputs {\n      .assign-dnd-panel__body {\n        background: #fafbfc;\n      }\n\n      .assign-dnd-panel__pagination {\n        background: #fafbfc;\n      }\n    }\n\n    &--outputs {\n      .assign-dnd-panel__body {\n        background: #f8fafc;\n      }\n\n      .assign-dnd-panel__pagination {\n        background: #f8fafc;\n      }\n    }\n  }\n\n  .assign-dnd-search {\n    margin-bottom: 0 !important;\n    max-width: 220px;\n  }\n\n  .assign-dnd-panel__head-actions {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    flex-shrink: 0;\n  }\n\n  .assign-dnd-empty {\n    font-size: 0.8125rem;\n    color: #94a3b8;\n    text-align: center;\n    padding: 16px 8px;\n    margin: 0;\n  }\n\n  .assign-dnd-link {\n    background: none;\n    border: none;\n    padding: 0;\n    color: var(--m-primary, #2563eb);\n    cursor: pointer;\n    font-size: inherit;\n    text-decoration: underline;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  .assign-dnd-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 7px 10px;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    cursor: grab;\n    transition:\n      border-color 0.12s ease,\n      box-shadow 0.12s ease,\n      background 0.12s ease;\n    user-select: none;\n\n    &:hover {\n      border-color: #93c5fd;\n      box-shadow: 0 2px 6px rgba(37, 99, 235, 0.08);\n    }\n\n    &:active {\n      cursor: grabbing;\n    }\n\n    &--selected {\n      background: #eff6ff;\n      border-color: #3b82f6;\n    }\n\n    &--assigned {\n      border-color: #86efac;\n      background: #f0fdf4;\n    }\n\n    &__labels {\n      display: flex;\n      flex-direction: column;\n      gap: 1px;\n      flex: 1;\n      min-width: 0;\n    }\n\n    &__entry {\n      font-size: 0.8125rem;\n      font-weight: 600;\n      color: #0f172a;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    &__variant {\n      font-size: 0.75rem;\n      color: #64748b;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .assign-dnd-output {\n    width: 100%;\n    flex-shrink: 0;\n\n    &__card {\n      box-sizing: border-box;\n      display: flex;\n      flex-direction: column;\n      align-items: stretch;\n      gap: 8px;\n      width: 100%;\n      padding: 10px 12px;\n      background: #fff;\n      border: 2px dashed #cbd5e1;\n      border-radius: 10px;\n      min-height: 56px;\n      transition:\n        border-color 0.14s ease,\n        background 0.14s ease,\n        box-shadow 0.14s ease;\n    }\n\n    &--over &__card {\n      border-color: var(--m-primary, #2563eb);\n      background: #eff6ff;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);\n    }\n\n    &--assigned &__card {\n      border-style: solid;\n      border-color: #86efac;\n      background: #f0fdf4;\n    }\n\n    &--assigned.assign-dnd-output--over &__card {\n      border-color: var(--m-primary, #2563eb);\n      background: #eff6ff;\n    }\n\n    &__head {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 8px;\n      flex: 0 0 auto;\n    }\n\n    &__label {\n      font-size: 0.8125rem;\n      font-weight: 600;\n      color: #0f172a;\n      margin: 0;\n      flex: 1;\n      min-width: 0;\n      line-height: 1.35;\n    }\n\n    &__head-actions {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      flex-shrink: 0;\n    }\n\n    &__clear,\n    &__exclude {\n      flex-shrink: 0;\n    }\n\n    &__metrics {\n      width: 100%;\n\n      &--compact {\n        display: flex;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: space-between;\n        gap: 8px;\n        padding-top: 6px;\n        border-top: 1px solid #e2e8f0;\n      }\n    }\n\n    &__weight-row {\n      display: inline-flex;\n      align-items: baseline;\n      gap: 6px;\n      min-width: 0;\n    }\n\n    &__weight-label {\n      font-size: 0.65rem;\n      font-weight: 600;\n      color: #94a3b8;\n      text-transform: uppercase;\n      letter-spacing: 0.02em;\n      white-space: nowrap;\n    }\n\n    &__weight-mini {\n      font-size: 0.72rem;\n      font-weight: 600;\n      color: #475569;\n      white-space: nowrap;\n\n      &--na {\n        color: #94a3b8;\n      }\n    }\n\n    &__wastage-mini {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      margin-left: auto;\n      flex-shrink: 0;\n    }\n\n    &__wastage-btn {\n      width: 26px !important;\n      height: 26px !important;\n      min-width: 26px;\n      padding: 0 !important;\n    }\n\n    &__wastage-badge {\n      font-size: 0.7rem;\n      font-weight: 600;\n      color: #b45309;\n      white-space: nowrap;\n    }\n\n    &__wastage-unit-hint {\n      font-size: 0.65rem;\n      font-weight: 600;\n      color: #94a3b8;\n      white-space: nowrap;\n    }\n\n    &__chips {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: flex-start;\n      align-content: flex-start;\n      gap: 6px;\n      width: 100%;\n      min-width: 0;\n      flex: 0 0 auto;\n      position: static;\n      margin: 0;\n      padding: 0;\n      border-top: none;\n    }\n\n    &--assigned &__chips {\n      padding-top: 2px;\n    }\n\n    &__placeholder {\n      font-size: 0.75rem;\n      color: #94a3b8;\n      font-style: italic;\n      line-height: 1.4;\n    }\n  }\n\n  .assign-dnd-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    max-width: 100%;\n    padding: 3px 8px 3px 10px;\n    background: #fff;\n    border: 1px solid #86efac;\n    border-radius: 999px;\n    font-size: 0.75rem;\n    color: #166534;\n    font-weight: 500;\n    line-height: 1.25;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    &__ratio-input {\n      user-select: text;\n      pointer-events: auto;\n      flex-shrink: 0;\n    }\n\n    &__remove {\n      background: none;\n      border: none;\n      padding: 0;\n      cursor: pointer;\n      color: #16a34a;\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n      transition: color 0.1s ease;\n\n      &:hover {\n        color: #dc2626;\n      }\n    }\n  }\n\n  .entry-edit-variants {\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    border: 1px solid var(--m-border-color, #e2e8f0);\n    border-radius: 10px;\n    background: #fafbfc;\n    overflow: hidden;\n  }\n\n  .entry-edit-section {\n    padding: 14px 16px;\n\n    & + & {\n      border-top: 1px solid var(--m-border-color, #e2e8f0);\n    }\n\n    &__title {\n      margin: 0 0 4px;\n      font-size: 0.8125rem;\n      font-weight: 700;\n      letter-spacing: 0.01em;\n      color: #334155;\n      text-transform: uppercase;\n    }\n\n    &__desc {\n      margin: 0 0 10px;\n      font-size: 0.75rem;\n      line-height: 1.45;\n      color: #64748b;\n    }\n\n    &__head {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: flex-start;\n      justify-content: space-between;\n      gap: 10px 16px;\n      margin-bottom: 12px;\n    }\n\n    &--variants {\n      background: #fff;\n    }\n  }\n\n  .entry-edit-default-ratio {\n    max-width: 140px;\n  }\n\n  .entry-edit-stats {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px 8px;\n    flex-shrink: 0;\n\n    &__total {\n      font-size: 0.75rem;\n      color: #64748b;\n      font-weight: 500;\n    }\n  }\n\n  .entry-edit-toolbar {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-end;\n    gap: 10px 14px;\n    margin-bottom: 12px;\n    padding: 10px 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #fff;\n\n    &__group {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 6px 8px;\n      min-width: 0;\n\n      &--bulk {\n        padding-left: 14px;\n        border-left: 1px solid #e2e8f0;\n\n        @media (max-width: 720px) {\n          padding-left: 0;\n          border-left: none;\n          width: 100%;\n        }\n      }\n    }\n\n    &__label {\n      flex-shrink: 0;\n      font-size: 0.6875rem;\n      font-weight: 700;\n      letter-spacing: 0.04em;\n      text-transform: uppercase;\n      color: #64748b;\n      margin-right: 2px;\n    }\n\n    &__ratio {\n      width: 88px;\n      flex-shrink: 0;\n    }\n  }\n\n  .entry-edit-empty {\n    margin: 0;\n    padding: 12px;\n    text-align: center;\n    font-size: 0.8125rem;\n    color: #94a3b8;\n    border: 1px dashed #e2e8f0;\n    border-radius: 8px;\n  }\n\n  .assign-variant-table-panel {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .assign-variant-table-pagination {\n    flex-shrink: 0;\n    padding-top: 2px;\n  }\n\n  .entry-variant-table-wrap {\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background: #fff;\n    overflow: hidden;\n\n    &--scroll {\n      height: 400px;\n      max-height: 400px;\n      overflow-y: auto;\n      overflow-x: auto;\n      flex-shrink: 0;\n    }\n  }\n\n  .assign-metric {\n    display: inline-flex;\n    align-items: baseline;\n    gap: 3px;\n    white-space: nowrap;\n\n    &__value {\n      font-weight: inherit;\n    }\n\n    &__unit {\n      font-size: 0.92em;\n      font-weight: 600;\n      color: #64748b;\n    }\n  }\n\n  .assign-qty-with-unit {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n\n    &__suffix {\n      flex-shrink: 0;\n      font-size: 0.8125rem;\n      font-weight: 600;\n      color: #64748b;\n      white-space: nowrap;\n    }\n\n    &--grid {\n      justify-content: flex-end;\n    }\n  }\n\n  .entry-edit-toolbar__ratio-wrap.assign-qty-with-unit {\n    flex: 0 1 140px;\n    min-width: 100px;\n  }\n\n  .entry-variant-grid {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed;\n\n    col.entry-variant-grid__col-check {\n      width: 52px;\n    }\n\n    col.entry-variant-grid__col-qty {\n      width: 128px;\n    }\n\n    thead th {\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      padding: 8px 10px;\n      font-size: 0.6875rem;\n      font-weight: 700;\n      letter-spacing: 0.03em;\n      text-transform: uppercase;\n      color: #64748b;\n      text-align: left;\n      background: #f1f5f9;\n      border-bottom: 1px solid #e2e8f0;\n      white-space: nowrap;\n\n      &.text-end {\n        text-align: right;\n      }\n\n      &:first-child,\n      &:nth-child(2) {\n        text-align: center;\n      }\n    }\n\n    tbody td {\n      padding: 8px 10px;\n      vertical-align: middle;\n      border-bottom: 1px solid #f1f5f9;\n    }\n\n    tbody tr:last-child td {\n      border-bottom: none;\n    }\n\n    &__row--active td {\n      background: #f8fafc;\n    }\n\n    &__row--bulk td:first-child {\n      box-shadow: inset 3px 0 0 #3b82f6;\n    }\n\n    &__row--excluded td {\n      opacity: 0.55;\n      background: #fafafa;\n    }\n\n    &__cell-check {\n      text-align: center;\n      width: 52px;\n    }\n\n    &__check {\n      display: inline-flex;\n      justify-content: center;\n      vertical-align: middle;\n\n      [class*=\"checkbox-container\"] {\n        margin: 0;\n\n        label:empty {\n          display: none;\n          width: 0;\n          margin: 0;\n          padding: 0;\n        }\n      }\n    }\n\n    &__cell-label {\n      min-width: 0;\n    }\n\n    &__name {\n      display: block;\n      font-size: 0.8125rem;\n      font-weight: 600;\n      color: #334155;\n      line-height: 1.35;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    &__code {\n      display: block;\n      font-size: 0.6875rem;\n      color: #94a3b8;\n      font-family: ui-monospace, monospace;\n      line-height: 1.3;\n    }\n\n    &__cell-qty {\n      text-align: right;\n    }\n\n    &__qty-input {\n      width: 88px;\n      max-width: 100%;\n      margin-left: auto;\n    }\n  }\n\n  // Entry multi-select bulk bar\n  // (removed)\n}\n\n// ---- View page (read-only) ----\n\n.part-machine-view {\n  .pm-view__topbar {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 0 6px;\n    margin-bottom: 10px;\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n      align-items: stretch;\n    }\n  }\n\n  .pm-view__machine {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 10px 12px;\n    border: 1px solid var(--m-border-color, #e2e8f0);\n    border-radius: 10px;\n    background: linear-gradient(180deg, #f8fafc, #ffffff);\n    min-width: 0;\n  }\n\n  .pm-view__machine-label {\n    font-size: 0.75rem;\n    color: #64748b;\n    line-height: 1.1;\n  }\n\n  .pm-view__machine-value {\n    font-size: 0.9375rem;\n    font-weight: 700;\n    color: #0f172a;\n  }\n\n  .pm-view__stats {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .pm-view__part {\n    border: 1px solid var(--m-border-color, #e2e8f0);\n    border-radius: 14px;\n    overflow: hidden;\n    background: #fff;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n    margin-top: 12px;\n\n    &--ok {\n      border-color: #86efac;\n    }\n    &--warn {\n      border-color: #fde68a;\n    }\n  }\n\n  .pm-view__part-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 14px 16px;\n    background: #f8fafc;\n    border-bottom: 1px solid #f1f5f9;\n  }\n\n  .pm-view__part-toggle {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    border: none;\n    background: transparent;\n    text-align: left;\n    cursor: pointer;\n\n    &:hover .pm-view__part-title {\n      color: var(--m-primary, #2563eb);\n    }\n  }\n\n  .pm-view__part-chevron {\n    color: #94a3b8;\n    margin-top: 2px;\n    flex-shrink: 0;\n  }\n\n  .pm-view__part-title-wrap {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .pm-view__part-num {\n    flex-shrink: 0;\n    width: 30px;\n    height: 30px;\n    border-radius: 10px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.8125rem;\n    font-weight: 800;\n    background: var(--m-primary, #2563eb);\n    color: #fff;\n  }\n\n  .pm-view__part-title {\n    font-size: 0.95rem;\n    font-weight: 800;\n    color: #0f172a;\n    transition: color 0.12s ease;\n  }\n\n  .pm-view__part-sub {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    font-size: 0.8125rem;\n    margin-top: 4px;\n  }\n\n  .pm-view__issues {\n    font-weight: 700;\n    color: #b45309;\n    background: #fffbeb;\n    border: 1px solid #fde68a;\n    padding: 1px 8px;\n    border-radius: 999px;\n  }\n\n  .pm-view__part-badges {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n\n  .pm-view__part-body {\n    padding: 12px 16px 16px;\n    background: #fff;\n  }\n\n  .pm-view__tabs {\n    margin-top: 6px;\n  }\n\n  .pm-view__section {\n    margin-top: 14px;\n  }\n\n  .pm-view__section-head {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 0.875rem;\n    font-weight: 800;\n    color: #0f172a;\n    margin-bottom: 8px;\n  }\n\n  .pm-view__table-panel {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .pm-view__pagination {\n    flex-shrink: 0;\n  }\n\n  .pm-view__table-wrap {\n    overflow-x: auto;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n\n    &--scroll {\n      height: 400px;\n      max-height: 400px;\n      overflow-y: auto;\n      overflow-x: auto;\n      flex-shrink: 0;\n    }\n  }\n\n  .pm-view__table {\n    width: 100%;\n    font-size: 0.8125rem;\n    border-collapse: collapse;\n\n    th,\n    td {\n      padding: 9px 12px;\n      text-align: left;\n      border-bottom: 1px solid #f1f5f9;\n      vertical-align: top;\n    }\n\n    th {\n      font-weight: 800;\n      color: #64748b;\n      background: #f8fafc;\n      white-space: nowrap;\n    }\n\n    .pm-view__table-wrap--scroll & thead th {\n      position: sticky;\n      top: 0;\n      z-index: 1;\n      box-shadow: 0 1px 0 #e2e8f0;\n    }\n\n    tbody tr:last-child td {\n      border-bottom: none;\n    }\n  }\n\n  .pm-view__assign-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    &--scroll {\n      max-height: 96px;\n      overflow-y: auto;\n      padding-right: 4px;\n    }\n\n    li {\n      padding: 3px 8px;\n      background: #f0fdf4;\n      border: 1px solid #bbf7d0;\n      border-radius: 6px;\n      font-size: 0.75rem;\n      color: #166534;\n      word-break: break-word;\n      flex-shrink: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
